module.exports = __webpack_public_path__ + "static/media/empty-filter.3a8017e6.svg";